export const warning = {
  lighter: '#FFF1E0',
  light: '#FFC98A',
  main: '#FF9013',
  dark: '#CC740F',
  darker: '#99570B',
  contrastText: '#1A1A1A',

  lighterChannel: '255 241 224',
  lightChannel: '255 201 138',
  mainChannel: '255 144 19',
  darkChannel: '204 116 15',
  darkerChannel: '153 87 11',
  contrastTextChannel: '26 26 26'
};

export const success = {
  lighter: '#E8F5E9',
  light: '#A5D6A7',
  main: '#22C55E',
  dark: '#2E7D32',
  darker: '#1B5E20',
  contrastText: '#FFFFFF',
  lighterChannel: '232 245 233',
  lightChannel: '165 214 167',
  mainChannel: '67 160 71',
  darkChannel: '46 125 50',
  darkerChannel: '27 94 32',
  contrastTextChannel: '255 255 255'
};

export const error = {
  lighter: '#FFE9D5',
  light: '#FFAC82',
  main: '#FF5630',
  dark: '#B71D18',
  darker: '#7A0916',
  contrastText: '#FFFFFF',
  lighterChannel: '255 233 213',
  lightChannel: '255 172 130',
  mainChannel: '255 86 48',
  darkChannel: '183 29 24',
  darkerChannel: '122 9 22',
  contrastTextChannel: '255 255 255'
};

export const grey = {
  0: '#FFFFFF',
  50: '#F8FAFC',
  100: '#F1F5F9',
  200: '#E2E8F0',
  300: '#CBD5E1',
  400: '#94A3B8',
  500: '#64748B',
  600: '#475569',
  700: '#334155',
  800: '#1E293B',
  900: '#0F172A',
  A100: '#f5f5f5',
  A200: '#eeeeee',
  A400: '#bdbdbd',
  A700: '#616161',
  '50Channel': '248 250 252',
  '100Channel': '241 245 249',
  '200Channel': '226 232 240',
  '300Channel': '203 213 225',
  '400Channel': '148 163 184',
  '500Channel': '100 116 139',
  '600Channel': '71 85 105',
  '700Channel': '51 65 85',
  '800Channel': '30 41 59',
  '900Channel': '15 23 42'
};
